module.exports = __webpack_public_path__ + "static/media/close-hand-min.3794f794.jpg";